// The reshare-pool marker's data (owner 2026-10-27 "add marker on our desk on the listing being in reshare pool").
// A tiny shared store instead of one more *ByProperty prop: IntakeTab fills it for the visible page (same id set as the
// cooperation / 🔗 chips), and the card body reads its own property - whichever list rendered it.
import { useSyncExternalStore } from 'react'

let byProperty = {}
const subs = new Set()

export function mergeReshareStatus(fetchedIds, rows) {
  const next = { ...byProperty }
  for (const pid of fetchedIds) next[pid] = rows[pid] || null   // fetched-empty = null, so absence is deterministic
  byProperty = next
  for (const f of subs) f()
}

const subscribe = f => { subs.add(f); return () => subs.delete(f) }
export function useReshareStatus(propertyId) {
  return useSyncExternalStore(subscribe, () => (propertyId ? byProperty[propertyId] || null : null))
}
